import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    CartesianGrid,
} from "recharts";
import { useMemo, useState } from "react";

const FilesOverviewChart = ({ data }) => {
    const [range, setRange] = useState("12");

    const filteredData = useMemo(() => {
        if (!data) return [];
        return range === "6" ? data.slice(0, 6) : data;
    }, [data, range]);

    return (
        <div className="bg-white rounded-[14px] border border-[#e4e5e7] p-[20px] md:p-[24px]">

            {/* Header */}
            <div className="flex items-center justify-between mb-[20px]">
                <h3 className="font-semibold text-[16px] text-[#212326]">
                    Files Overview
                </h3>

                <select
                    value={range}
                    onChange={(e) => setRange(e.target.value)}
                    className="appearance-none bg-[#f4f5f6] border-none rounded-[8px] px-[12px] py-[6px] text-[12px] font-medium text-[#212326] cursor-pointer focus:outline-none"
                >
                    <option value="12">Last 12 months</option>
                    <option value="6">Last 6 months</option>
                </select>
            </div>

            {/* Chart */}
            <ResponsiveContainer width="100%" height={240}>
                <AreaChart data={filteredData}>

                    {/* GRID (like your UI) */}
                    <CartesianGrid
                        stroke="#f0f1f3"
                        strokeDasharray="3 3"
                        vertical={false}
                    />

                    <XAxis
                        dataKey="month"
                        tick={{ fill: "#9298a0", fontSize: 11 }}
                        axisLine={false}
                        tickLine={false}
                    />

                    <YAxis
                        tick={{ fill: "#9298a0", fontSize: 11 }}
                        axisLine={false}
                        tickLine={false}
                    />

                    <Tooltip content={<CustomTooltip />} />

                    {/* Gradient (same as your Files chart) */}
                    <defs>
                        <linearGradient id="overviewColor" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#ff5323" stopOpacity={0.2} />
                            <stop offset="95%" stopColor="#ff5323" stopOpacity={0} />
                        </linearGradient>
                    </defs>

                    {/* Area */}
                    <Area
                        type="monotone"
                        dataKey="Files"
                        stroke="#ff5323"
                        fill="url(#overviewColor)"
                        strokeWidth={2.5}
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    );
};

const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) return null;

    return (
        <div className="bg-[#212326] text-white text-[12px] px-[14px] py-[10px] rounded-[10px] shadow-md">
            <p className="text-[#9298a0] text-[11px] mb-1">{label}</p>

            <p className="font-medium">
                {payload[0].name}: {payload[0].value} Files
            </p>
        </div>
    );
};

export default FilesOverviewChart;